import { render } from "./InvoicesSeriesView.vue?vue&type=template&id=56d6cfc4"
import script from "./InvoicesSeriesView.vue?vue&type=script&lang=js"
export * from "./InvoicesSeriesView.vue?vue&type=script&lang=js"

import "./InvoicesSeriesView.vue?vue&type=style&index=0&id=56d6cfc4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__